'use client';

import { DefinitionList, RadioField, SkeletonBar } from '@petsmart-ui/sparky';

import { clsx } from '@libs/common-next';
import { capitalize } from '@libs/core';

import type { ColorToggleProps } from '@app/pdp/components/ColorToggle/types';
import { useInventories } from '@app/pdp/entities/inventories';

import './ColorToggle.scss';
import ColorToggleItem from './ColorToggleItem';

export default function ColorToggle({
    items,
    className,
    variantKey,
    hideLegend = true,
    label = 'Select a color',
    selectedValue,
    title = 'Color',
    toggleColors,
    ...other
}: ColorToggleProps) {
    const { isLoading: inventoryLoading } = useInventories();

    const componentClassName = clsx('color-toggle', className);

    return (
        <div data-testid="color-toggle" className={componentClassName}>
            <DefinitionList variant="highlight-definition">
                <DefinitionList.Item title={`${capitalize(title)}:`}>
                    {
                        items.find(color => color.value === selectedValue)
                            ?.display
                    }
                </DefinitionList.Item>
            </DefinitionList>
            <RadioField
                className="c-color-toggle__radio-field"
                label={label}
                hideLegend={hideLegend}
                selectedValue={selectedValue}
                onChange={toggleColors}
                variant="toggle"
                data-testid="radio-field"
                {...other}
            >
                {items.length > 1 &&
                    items.map(({ key, ...props }) =>
                        inventoryLoading ? (
                            <SkeletonBar key={key} />
                        ) : (
                            <ColorToggleItem
                                key={key}
                                variantKey={variantKey}
                                {...props}
                            />
                        )
                    )}
            </RadioField>
        </div>
    );
}
